import {Heading, Pane} from 'evergreen-ui';
import React, {memo} from 'react';

import {CloseButton} from '../../common';


type Props = {
    caseNumber: string;
    hasCloseBtn?: boolean;
    conversationExt?: React.ReactNode;
    onClose: () => void;
};

export const OfferFormHeader = memo(function OfferFormHeader({caseNumber, onClose, hasCloseBtn = true, conversationExt = undefined }: Props) {
    return (
        <Pane className="flex justify-between sticky top-0 portal-provider-bg z-10 portal-provider-offer-form-header">
            <Heading size={600} fontWeight="bolder" display="flex" alignItems='center'>Offer for Referral {caseNumber} {conversationExt}</Heading>
            {hasCloseBtn && <CloseButton className="mr-12" onClick={onClose}/> }
        </Pane>
    );
});
